/**
 * Utility functions for handling images
 */

/**
 * Ensures Unsplash URLs have proper parameters to prevent 404 errors
 * @param url - The image URL
 * @param width - Desired width (default: 800)
 * @param height - Desired height (default: 600)
 * @returns Properly formatted image URL
 */
export function getOptimizedImageUrl(
  url: string | undefined | null,
  width: number = 800,
  height: number = 600,
  quality: number = 75
): string {
  // Fallback URL with proper parameters - higher compression
  const fallbackUrl = `https://images.unsplash.com/photo-1569163139394-de4b5c3c4745?w=${width}&h=${height}&fit=crop&auto=format&q=${quality}`;
  
  if (!url) return fallbackUrl;
  
  // If it's a WordPress/WP Engine URL, add optimization parameters
  if (url.includes('wpenginepowered.com') || url.includes('vibemake')) {
    const urlObj = new URL(url);
    // Add WordPress image optimization parameters
    urlObj.searchParams.set('w', width.toString());
    urlObj.searchParams.set('h', height.toString());
    urlObj.searchParams.set('fit', 'crop');
    urlObj.searchParams.set('auto', 'compress,format');
    urlObj.searchParams.set('q', quality.toString());
    return urlObj.toString();
  }
  
  // If it's an Unsplash URL without parameters, add them
  if (url.includes('unsplash.com') && !url.includes('?')) {
    return `${url}?w=${width}&h=${height}&fit=crop&auto=format&q=${quality}`;
  }
  
  // If it's an Unsplash URL with incomplete parameters, ensure all are present
  if (url.includes('unsplash.com') && url.includes('?')) {
    const urlObj = new URL(url);
    if (!urlObj.searchParams.has('w')) urlObj.searchParams.set('w', width.toString());
    if (!urlObj.searchParams.has('h')) urlObj.searchParams.set('h', height.toString());
    if (!urlObj.searchParams.has('fit')) urlObj.searchParams.set('fit', 'crop');
    if (!urlObj.searchParams.has('auto')) urlObj.searchParams.set('auto', 'format');
    if (!urlObj.searchParams.has('q')) urlObj.searchParams.set('q', quality.toString());
    return urlObj.toString();
  }
  
  return url;
}